import { Feature } from "@omni/types/api/product/bff/shared/feature.model";
import { KeyFeatures as KeyFeaturesBase } from "@omni/ui/components/Product/Feature/KeyFeatures/keyFeatures";
import { cn } from "@omni/utils/styles";

import { KeyFeaturesComponent } from "./keyFeatures.component";

type Props = {
    features: Array<Feature>;
    className?: string;
};

export const KeyFeatures = ({ features, className }: Props) => {
    return (
        <KeyFeaturesBase
            features={features}
            className={cn(className)}
        >
            <KeyFeaturesComponent />
        </KeyFeaturesBase>
    );
};
